// web-ctr/src/components/Wordmark.jsx
// The clearedto.rent lockup: "clearedto", the NDEMNIFLY paper-plane as the
// dot, "rent" (DESIGN-BRIEF wordmark rules; the placeholder glyph is dead per
// addendum §10). The plane tints via currentColor through a CSS mask because
// the SVG's internal clipPath ids would collide if the file were inlined
// twice on one page (nav + footer). Only used at >=16px cap height; below
// that the rule is plain text "clearedto.rent", no mark.
import planeUrl from '@/assets/paper-plane.svg';

const maskStyle = {
  maskImage: `url(${planeUrl})`,
  maskSize: 'contain',
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskImage: `url(${planeUrl})`,
  WebkitMaskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
};

export default function Wordmark({ className = '', tailClassName = 'text-accent' }) {
  return (
    <span className={`inline-flex items-baseline font-bold tracking-tight ${className}`}>
      clearedto
      <span className={`inline-flex items-baseline ${tailClassName}`}>
        <span
          aria-hidden="true"
          className="mx-[0.06em] inline-block h-[0.5em] w-[0.62em] self-center bg-current"
          style={maskStyle}
        />
        rent
      </span>
    </span>
  );
}
